import * as d3 from 'd3';
import Axis from './Axis.js';

export default class MonthAxis extends Axis {
  constructor(props) {
    super(props);

    this.axis = d3.axisBottom(this.xScale).ticks(d3.timeMonth.every(1));
  }

  remove() {
    const { chart } = this.props;

    chart.selectAll('.month .tick text').remove();

    return this;
  }

  addMonthGrid() {
    const {
      chart,
      options: { height, scaleType },
    } = this.props;
    chart
      .selectAll('.month .tick')
      .select('line')
      .transition()
      .duration(0)
      .attr('stroke-dasharray', `${scaleType === 'quarter' ? '3.3' : false}`)
      .attr('y2', height);

    return this;
  }

  removeDomainPath() {
    const { chart } = this.props;

    chart.select('.month .domain').remove();

    return this;
  }

  update() {
    const { chart } = this.props;

    this.axis.scale(this.xScale);

    chart
      .select('.axis.month')
      .transition()
      .duration(this.transitionDuration)
      .call(this.axis);

    this.remove().addMonthGrid().removeDomainPath();
  }

  build() {
    const { chart } = this.props;

    chart
      .append('g')
      .attr('class', 'axis month')
      .attr('transform', 'translate(0,0)')
      .call(this.axis);

    this.remove().addMonthGrid().removeDomainPath();
  }
}
